// extracted by mini-css-extract-plugin
var _1 = "EmailProfileMessageBody-moduleEmailProfileMessageBody__QbesC";
var _2 = "EmailProfileMessageBody-modulemessageContainer__YHEjZ ScrollContainer-moduleScrollContainer__LHyVB";
var _3 = "EmailProfileMessageBody-modulemessageLink___CNn5";
var _4 = "EmailProfileMessageBody-modulemessageThreadHeader__xrsAP";
var _5 = "EmailProfileMessageBody-modulepaperView__hnYh1";
var _6 = "EmailProfileMessageBody-modulethemeView__CT_8e";
export { _1 as "EmailProfileMessageBody", _2 as "messageContainer", _3 as "messageLink", _4 as "messageThreadHeader", _5 as "paperView", _6 as "themeView" }
